import {InternalUserRole} from '@amplify/athena-models';

export const allRoles = [
    {role: InternalUserRole.AGENT, displayName: 'Agent'},
    {role: InternalUserRole.MANAGER, displayName: 'Manager'},
    {role: InternalUserRole.AP_MANAGER, displayName: 'Agent Portal Manager'},
    {role: InternalUserRole.AGENIUM_AGENT, displayName: 'Agenium Agent'},
];

export const roleToNameMap: Map<InternalUserRole, string> = new Map(allRoles.map((r) => [r.role, r.displayName]));
